module.exports = __webpack_public_path__ + "img/about2.a72e2a5b.png";